var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._t("default",function(){return [_vm._v("A very long header that should be ellipsed")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }